import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  type TermsMethodsKindEnum,
  TermsMethodsKinds,
} from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
// eslint-disable-next-line import/no-internal-modules
import { paymentTermRepository } from '@webapp/modules/vendor/data-access/repositories/PaymentTermRepository'
// eslint-disable-next-line import/no-internal-modules
import { shippingMethodRepository } from '@webapp/modules/vendor/data-access/repositories/ShippingMethodRepository'
// eslint-disable-next-line import/no-internal-modules
import { shippingTermRepository } from '@webapp/modules/vendor/data-access/repositories/ShippingTermRepository'
// eslint-disable-next-line import/no-internal-modules
import { type PaymentTerm } from '@webapp/modules/vendor/entities/PaymentTerm'
// eslint-disable-next-line import/no-internal-modules
import { type ShippingMethod } from '@webapp/modules/vendor/entities/ShippingMethod'
// eslint-disable-next-line import/no-internal-modules
import { type ShippingTerm } from '@webapp/modules/vendor/entities/ShippingTerm'
import {
  paymentTermQueryConfig,
  shippingMethodQueryConfig,
  shippingTermQueryConfig,
} from '@webapp/modules/vendor/query-configs' // eslint-disable-line import/no-internal-modules

export type TermOrMethod = ShippingTerm | PaymentTerm | ShippingMethod

// Kind-switch lives in the Model layer, not the Feature Set
const KIND_REPOSITORIES = {
  [TermsMethodsKinds.SHIPPING_TERMS]: shippingTermRepository,
  [TermsMethodsKinds.PAYMENT_TERMS]: paymentTermRepository,
  [TermsMethodsKinds.SHIPPING_METHODS]: shippingMethodRepository,
} as const

const KIND_QUERY_CONFIGS = {
  [TermsMethodsKinds.SHIPPING_TERMS]: shippingTermQueryConfig,
  [TermsMethodsKinds.PAYMENT_TERMS]: paymentTermQueryConfig,
  [TermsMethodsKinds.SHIPPING_METHODS]: shippingMethodQueryConfig,
} as const

export const useMutateDeleteTermOrMethod = (kind: TermsMethodsKindEnum) => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, number>({
    // Canonical trailing-slash DELETE — no 301 hop (BHV-031)
    mutationFn: (id: number) => KIND_REPOSITORIES[kind].delete(id),
    onSuccess: () => {
      // Per-kind isolation — invalidate only the active kind's aggregate
      queryClient.invalidateQueries({
        queryKey: KIND_QUERY_CONFIGS[kind].all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
